import {
    Component,
    ojs,
    app,
    state,
    v,
    payload,
    component,
} from "modular-openscriptjs";
import {
    pageInfo,
    formatThousand,
    formatDateForHumans,
    either,
    scrollToTop,
    isMobile,
    cleanDispose,
    inform,
    eParse,
    updateStateValue,
    randomLightGradient,
    empty,
    monetary,
    setCurrentLocationCoordinates,
} from "../../helpers";
import { api, dc, STRINGS } from "../../declarations";
import { $e } from "../../ojs.events";
import SolidIcon from "../Blocks/SolidIcon";
import OffcanvasBody from "../Offcanvas/OffcanvasBody";
import ModalBody from "../Modals/ModalBody";
import Spinner from "../Blocks/Spinner";
import ViewOrder from "./ViewOrder";
import AudioPlayerView from "../Views/Order/AudioPlayerView";
import OrderOverview from "../Blocks/OrderOverview";
import { dom, tool } from "../../fotastart";
import ProcessOrderForm from "../Forms/ProcessOrderForm";
import { ac, gc } from "../../ojs.contexts";
import { Capacitor } from "@capacitor/core";
import { getFirebaseToken } from "../../firebase";

const h = app("h");
const broker = app("broker");
const router = app("router");

ojs(
    SolidIcon,
    OffcanvasBody,
    ModalBody,
    Spinner,
    ViewOrder,
    AudioPlayerView,
    OrderOverview,
    ProcessOrderForm,
);

export default class Orders extends Component {
    companyId = state(null);
    orders = state([]);
    loading = state(true);
    currentPage = state(1);
    paginationInfo = state(null);
    currentOrder = state(null);
    swipeStartX = 0;
    swipeStartY = 0;
    swipeStartTime = 0;

    filters = state({
        status: [gc.user.type == "deliverer" ? "ready" : "processing"],
        from_date: "",
        to_date: "",
    });

    filterHolder = null;
    cardGradients = {};

    getOrderGradient(orderId) {
        if (!this.cardGradients[orderId]) {
            this.cardGradients[orderId] = randomLightGradient();
        }
        return this.cardGradients[orderId];
    }

    $$order = {
        has: {
            businessOrders: (ed) => {
                let data = eParse(ed);
                let orders = data.message.orders.data;
                
                let orderMap = {};
                
                for (let order of orders) {
                    orderMap[order.id] = order;
                }
                
                this.orders.value = orderMap;
                ac.orders.value = orderMap;

                this.paginationInfo.value = {
                    current_page: data.message.orders.current_page,
                    last_page: data.message.orders.last_page,
                    total: data.message.orders.total,
                };
                this.loading.value = false;
            },
            updatedStatus: () => {
                this.fetchOrders();
            },
        },
        statusChanged: () => {
            this.fetchOrders();
        },
        is: {
            transferred: () => {
                this.fetchOrders();
            },
        },
    };

    selectStatus(statusKey) {
        updateStateValue(this.filters, (v) => {
            v.status = [statusKey];
            return v;
        });
        this.currentPage.value = 1;
        this.fetchOrders();

        setTimeout(() => {
            let s = dom.get(`[status-active="true"]`);

            if (s) {
                s.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "nearest",
                });
            }
        }, 100);
    }

    selectPreviousStatus() {
        const currentStatus = this.filters.value.status[0] || "processing";
        const statusKeys = [
            "dispute",
            "confirmed",
            "processing",
            "ready",
            "delivering",
            "completed",
            "cancelled",
        ];
        const currentIndex = statusKeys.indexOf(currentStatus);

        let prevIndex = currentIndex - 1;
        if (prevIndex < 0) {
            prevIndex = statusKeys.length - 1;
        }

        this.selectStatus(statusKeys[prevIndex]);
    }

    selectNextStatus() {
        const currentStatus = this.filters.value.status[0] || "processing";
        const statusKeys = [
            "dispute",
            "confirmed",
            "processing",
            "ready",
            "delivering",
            "completed",
            "cancelled",
        ];
        const currentIndex = statusKeys.indexOf(currentStatus);

        let nextIndex = currentIndex + 1;
        if (nextIndex >= statusKeys.length) {
            nextIndex = 0;
        }

        this.selectStatus(statusKeys[nextIndex]);
    }

    onPointerDown(e) {
        if (!e.isPrimary) return;
        this.swipeStartX = e.clientX;
        this.swipeStartY = e.clientY;
        this.swipeStartTime = Date.now();

        try {
            e.target.setPointerCapture(e.pointerId);
        } catch (err) {}
    }

    onPointerUp(e) {
        if (!e.isPrimary) return;

        try {
            e.target.releasePointerCapture(e.pointerId);
        } catch (err) {}

        const deltaX = e.clientX - this.swipeStartX;
        const deltaY = e.clientY - this.swipeStartY;
        const duration = Date.now() - this.swipeStartTime;

        if (
            Math.abs(deltaX) > 60 &&
            Math.abs(deltaX) > Math.abs(deltaY) &&
            duration < 800
        ) {
            if (deltaX > 0) {
                this.selectPreviousStatus();
            } else {
                this.selectNextStatus();
            }
        }
    }

    renderStickyStatusCard() {
        const statusList = [
            { key: "dispute", label: "Dispute" },
            { key: "confirmed", label: "Confirmed" },
            { key: "processing", label: "Processing" },
            { key: "ready", label: "Ready" },
            { key: "delivering", label: "Delivering" },
            { key: "completed", label: "Completed" },
            { key: "cancelled", label: "Cancelled" },
        ];

        return v(this.filters, (filt) => {
            const currentStatus = filt.value.status[0] || "confirmed";

            return h.div(
                {
                    class: "card border-0 shadow-sm rounded-4 mb-4 sticky-top bg-white bg-opacity-95",
                    style: "top: 65px; z-index: 1010; backdrop-filter: blur(10px); border: 1px solid rgba(0,0,0,0.05) !important;",
                },
                h.div(
                    {
                        class: "card-body p-2 d-flex align-items-center justify-content-between gap-2",
                    },
                    h.button(
                        {
                            class: "btn btn-white border circle shadow-sm p-2 d-flex align-items-center justify-content-center",
                            style: "width: 40px; height: 40px;",
                            listeners: {
                                click: () => this.selectPreviousStatus(),
                            },
                        },
                        h.i({ class: "bi bi-chevron-left fw-bold" }),
                    ),

                    h.div(
                        {
                            class: "d-flex gap-2 flex-grow-1 overflow-x-auto no-scrollbar py-1 align-items-center justify-content-md-center",
                            style: "scrollbar-width: none; -ms-overflow-style: none;",
                        },
                        ...statusList.map((status) => {
                            const isActive = currentStatus === status.key;
                            const getActiveStatusStyles = (key) => {
                                switch (key) {
                                    case "dispute":
                                        return {
                                            class: "btn-danger text-white shadow-sm scale-up",
                                            style: "",
                                        };
                                    case "confirmed":
                                        return {
                                            class: "btn-secondary text-white shadow-sm scale-up",
                                            style: "",
                                        };
                                    case "processing":
                                        return {
                                            class: "text-white shadow-sm scale-up",
                                            style: "background-color: #0d6efd !important; border-color: #0d6efd !important;",
                                        };
                                    case "ready":
                                        return {
                                            class: "btn-info text-white shadow-sm scale-up",
                                            style: "",
                                        };
                                    case "delivering":
                                        return {
                                            class: "btn-warning text-dark shadow-sm scale-up",
                                            style: "",
                                        };
                                    case "completed":
                                        return {
                                            class: "btn-success text-white shadow-sm scale-up",
                                            style: "",
                                        };
                                    case "cancelled":
                                        return {
                                            class: "btn-dark text-white shadow-sm scale-up",
                                            style: "",
                                        };
                                    default:
                                        return {
                                            class: "btn-primary text-white shadow-sm scale-up",
                                            style: "",
                                        };
                                }
                            };

                            const activeStyles = isActive
                                ? getActiveStatusStyles(status.key)
                                : null;
                            const btnAttrs = {
                                status_active: currentStatus === status.key,
                                class: `btn rounded-pill px-4 py-2.5 fw-bold text-nowrap transition-all ${
                                    isActive
                                        ? activeStyles.class
                                        : "btn-light text-secondary hover-light"
                                }`,
                                listeners: {
                                    click: () => this.selectStatus(status.key),
                                },
                            };

                            if (isActive && activeStyles.style) {
                                btnAttrs.style = activeStyles.style;
                            }

                            return h.button(btnAttrs, status.label);
                        }),
                    ),

                    h.button(
                        {
                            class: "btn btn-white border circle shadow-sm p-2 d-flex align-items-center justify-content-center",
                            style: "width: 40px; height: 40px;",
                            listeners: { click: () => this.selectNextStatus() },
                        },
                        h.i({ class: "bi bi-chevron-right fw-bold" }),
                    ),
                ),
            );
        });
    }

    renderOrdersPage() {
        return h.div(
            { class: "min-vh-100 pb-5 mb-5 py-md-5" },
            h.div(
                { class: "container__" },
                // Header
                h.div(
                    {
                        class: "mb-4 d-flex justify-content-between align-items-center",
                    },
                    h.div(
                        { class: "d-flex align-items-center gap-3" },
                        h.button(
                            {
                                class: "btn btn-white border shadow-sm circle p-2",
                                onclick: "app('router').back()",
                            },
                            h.SolidIcon("arrow-left"),
                        ),
                        h.div(
                            {},
                            h.h2(
                                {
                                    class: "fw-bold mb-0 h4 h2-md d-flex align-items-center gap-2 flex-wrap",
                                },
                                "Orders",
                            ),
                        ),
                    ),
                ),

                // Sticky status scrollbar card
                this.renderStickyStatusCard(),

                // Content
                h.div(
                    {
                        style: "touch-action: pan-y; min-height: 400px;",
                        listeners: {
                            pointerdown: (e) => this.onPointerDown(e),
                            pointerup: (e) => this.onPointerUp(e),
                        },
                    },
                    v(this.loading, (l) => {
                        if (l.value)
                            return h.div(
                                { class: "text-center py-5" },
                                h.Spinner(),
                            );

                        return v(this.orders, (o) => {
                            if (Object.values(o.value).length === 0) {
                                const currentStatus =
                                    this.filters.value.status[0] || "confirmed";
                                const getEmptyStateContent = (statusKey) => {
                                    switch (statusKey) {
                                        case "dispute":
                                            return {
                                                title: "No disputed orders",
                                                desc: "Awesome! There are no orders in dispute right now.",
                                            };
                                        case "confirmed":
                                            return {
                                                title: "No confirmed orders",
                                                desc: "Wait for orders to be confirmed by the company.",
                                            };
                                        case "processing":
                                            return {
                                                title: "No orders in processing",
                                                desc: "Orders currently being prepared or processed will appear here.",
                                            };
                                        case "ready":
                                            return {
                                                title: "No ready orders",
                                                desc: "Orders that are purchased/ready for pickup will appear here.",
                                            };
                                        case "delivering":
                                            return {
                                                title: "No orders in delivery",
                                                desc: "No orders are currently out for delivery.",
                                            };
                                        case "completed":
                                            return {
                                                title: "No completed orders",
                                                desc: "Orders you complete delivering will show up here.",
                                            };
                                        case "cancelled":
                                            return {
                                                title: "No cancelled orders",
                                                desc: "No cancelled orders for this company.",
                                            };
                                        default:
                                            return {
                                                title: "No orders found",
                                                desc: "No orders found matching the selected status.",
                                            };
                                    }
                                };
                                const emptyContent =
                                    getEmptyStateContent(currentStatus);

                                return h.div(
                                    {
                                        class: "card border-0 shadow-sm rounded-4 p-5 text-center bg-white",
                                    },
                                    h.div(
                                        {
                                            class: "bg-light rounded-circle p-4 mx-auto mb-3",
                                            style: "width: 80px; height: 80px;",
                                        },
                                        h.i({
                                            class: "bi bi-cart-x fs-1 text-muted opacity-50",
                                        }),
                                    ),
                                    h.h5(
                                        { class: "fw-bold mb-2" },
                                        emptyContent.title,
                                    ),
                                    h.p(
                                        { class: "text-muted mb-3" },
                                        emptyContent.desc,
                                    ),
                                    h.small(
                                        {
                                            class: "text-secondary d-flex align-items-center justify-content-center gap-2 opacity-75 fw-semibold",
                                        },
                                        h.i({ class: "bi bi-chevron-left" }),
                                        "Swipe to change status",
                                        h.i({ class: "bi bi-chevron-right" }),
                                    ),
                                );
                            }

                            return h.div(
                                {},
                                h.div(
                                    { class: "row g-2 mb-4" },
                                    ...Object.values(o.value).map((order) =>
                                        h.OrderOverview(
                                            order,
                                            this.method(
                                                "openOrderDetails",
                                                order?.id,
                                            ),
                                        ),
                                    ),
                                ),
                                this.renderPagination(),
                            );
                        });
                    }),
                ),
            ),
            h.div(
                {
                    class: "move-selected-orders fixed-bottom",
                    style: "z-index: 1035;",
                    id: "mass-action-cta-btn",
                },

                v(dc.selectedItems, (selectedItems) => {
                    if (Object.keys(selectedItems.value).length < 1)
                        return null;

                    return h.div(
                        { class: "card shadow rounded-pill mx-2 my-3" },

                        h.div(
                            {
                                class: "card-body",
                                onclick: this.method("purchaseItems"),
                            },

                            h.span(
                                {
                                    class: "d-flex gap-2 align-items-center justify-content-center text-success fw-500 fs-4",
                                },

                                h.i({
                                    class: "fas fa-hand-holding-dollar",
                                }),

                                h.span(
                                    "Purchase ",
                                    Object.keys(selectedItems.value).length,
                                    " Item" +
                                        `${
                                            Object.keys(selectedItems.value)
                                                .length > 1
                                                ? "s"
                                                : ""
                                        }`,
                                ),
                            ),
                        ),
                    );
                }),
            ),
        );
    }

    render(companyIdState) {
        scrollToTop();

        if (companyIdState) {
            if (this.companyId.value !== companyIdState.value) {
                this.companyId.value = companyIdState.value;
                this.fetchOrders();
            }
        }

        pageInfo("Manage Orders");

        return this.renderOrdersPage();
    }

    getStatusColor(status) {
        switch (status) {
            case "picked":
                return "success";
            case "pending":
                return "warning";
            case "queued":
                return "primary";
            case "preparing":
                return "info";
            case "ready":
                return "indigo";
            case "failed":
                return "danger";
            default:
                return "secondary";
        }
    }

    async fetchOrders() {
        this.loading.value = true;
        broker.broadcast(
            $e.order.needs.businessOrders,
            payload({
                companyId: this.companyId.value,
                filters: this.filters.value,
                page: this.currentPage.value,
                interval: 5,
            }),
        );
    }

    openOrderDetails(orderId) {
        broker.send($e.order.needs.refresh, payload({ orderId }));

        return broker.send($e.order.needs.processForm, payload({ orderId }));
    }

    purchaseItems() {
        broker.send($e.purchase.needs.creation);
    }

    changeOrderStatus(orderId, url, direction) {
        broker.send(
            $e.order.needs.statusChange,
            payload({
                orderId: orderId,
                url: url,
                direction: direction,
            }),
        );
    }

    renderPagination() {
        return v(this.paginationInfo, (info) => {
            if (!info.value || info.value.last_page <= 1) return h.empty();

            const currentPage = info.value.current_page;
            const lastPage = info.value.last_page;

            return h.div(
                {
                    class: "d-flex justify-content-between align-items-center mt-4 bg-white p-3 rounded-4 shadow-sm border border-light-subtle",
                },
                h.button(
                    {
                        class: "btn btn-sm btn-outline-primary rounded-pill fw-semibold d-flex align-items-center gap-2",
                        listeners: {
                            click: () => {
                                if (currentPage > 1) {
                                    this.currentPage.value = currentPage - 1;
                                    this.fetchOrders();
                                    scrollToTop();
                                }
                            },
                        },
                    },
                    either(currentPage === 1, { disabled: true }),
                    h.i({ class: "bi bi-arrow-left" }),
                    "Previous",
                ),
                h.span(
                    { class: "fw-bold text-secondary fs-6" },
                    `Page ${currentPage} of ${lastPage}`,
                ),
                h.button(
                    {
                        class: "btn btn-sm btn-outline-primary rounded-pill fw-semibold d-flex align-items-center gap-2",
                        listeners: {
                            click: () => {
                                if (currentPage < lastPage) {
                                    this.currentPage.value = currentPage + 1;
                                    this.fetchOrders();
                                    scrollToTop();
                                }
                            },
                        },
                    },
                    either(currentPage === lastPage, { disabled: true }),
                    "Next",
                    h.i({ class: "bi bi-arrow-right" }),
                ),
            );
        });
    }

    $_mounted(componentId) {
        let c = component(componentId);

        if (c) {
            let userType = gc.user.type;
            let defaultStatus = userType == "deliverer" ? "ready" : "processing";

            let status = router.qs.get("status") ?? defaultStatus;
            c.selectStatus(status);
            setCurrentLocationCoordinates(true, null, true);
        }

        if (Capacitor.isNativePlatform()) {
            getFirebaseToken();
        }
    }

    $$app = {
        has: {
            selectedOrderItems: (ed, event) => {
                let catBtn = dom.id("mass-action-cta-btn");

                let show =
                    !empty(dc.selectedOrders.value) ||
                    !empty(dc.selectedItems.value);

                if (show) {
                    catBtn?.classList.add("show");
                } else {
                    catBtn?.classList.remove("show");
                }
            },
        },
    };
}
